<!-- Languages -->
<p-button
  type="button"
  icon="pi pi-globe"
  (click)="toggleLanguagePopover($event)"
  text
/>

<p-popover #languagePopover>
  <ul class="m-0 flex list-none flex-col p-0">
    @for (language of languages; track language) {
      <li
        class="flex cursor-pointer items-center gap-3 rounded-xl px-3 py-1 hover:bg-gray-100"
        (click)="onChangeLanguage(language)"
      >
        <img
          [ngSrc]="'assets/icons/features/languages/' + language.image"
          [alt]="language.name + ' flag'"
          width="36"
          height="36"
        />
        <span
          [ngClass]="{
            'font-bold': translocoService.getActiveLang() === language.code,
          }"
        >
          {{ language.name }}
        </span>
      </li>
    }
  </ul>
</p-popover>
